import { configureStore } from "@reduxjs/toolkit";
// import counterReducer from './slices/counterSlice';
import data from './modules/index';


export const store = configureStore({
    reducer: {
        counter: data,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
    devTools: true,
})
